export default "__VITE_ASSET__BU0vW5rb__"